import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Button from '../Button';

export default () => (
  <>
    <Heading level={1}>Secondary Text-Link Button</Heading>
    <Spacer size={16} />
    <Text>
      Setting <Code>{'type="secondaryTextLink"'}</Code> on the{' '}
      <Code>{'<Button />'}</Code> component will render a secondary text-link
      button.
    </Text>
    <Spacer size={16} />
    <Text>
      Secondary Text-link button has the same structure as Text-link button
      except it doesn't use current user's competency level to determine color.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Button type="secondaryTextLink">Label</Button>
        <Spacer size={6} />
        <Text>Active</Text>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center" expand={false}>
        <Button type="secondaryTextLink" disabled={true}>
          Label
        </Button>
        <Spacer size={6} />
        <Code>{'disabled={true}'}</Code>
      </FlexView>
    </FlexView>
  </>
);
